'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @flow
var home = exports.home = {
  title: 'Aprende para ser <b>mejor</b>',
  description: 'Videoformación práctica de todo lo que necesitas',
  background_url: 'https://dev-res.thumbr.io/images/home-banner.jpg',
  whatis_title: '¿Qué es Tutellus?',
  whatis_description: 'Tutellus es la Plataforma de aprendizaje colaborativo más grande del mundo hispano. Con miles de videocursos y millones de alumnos, puedes utilizar Tutellus de 3 formas;',
  whatis_traits: '["t_learn", "t_teach", "t_promote"]',
  t_learn_icon: 'https://lib.tutellus.com/images/learn-icon.svg',
  t_learn_title: 'Aprende',
  t_learn_description: 'Como alumno, siempre encontrarás algo nuevo para aprender entre los miles de videocursos',
  t_teach_icon: 'https://lib.tutellus.com/images/teach-icon.svg',
  t_teach_title: 'Enseña',
  t_teach_description: 'Demuestra tus dotes docentes y saca partido a tus conocimientos convirtiéndote en profesor',
  t_promote_icon: 'https://lib.tutellus.com/images/promote-icon.svg',
  t_promote_title: 'Promueve',
  t_promote_description: 'Comparte los cursos de otros usuarios y empieza a ganar dinero como afiliado. ¡Así de fácil!',
  learn_title: 'Aprende en miles de Cursos',
  learn_description: 'Encuentra lo que necesitas entre más de 100.000 videocursos, de todas las temáticas y niveles. Aprende a tu ritmo con un gran Producto diseñado para que tú controles tu propio aprendizaje.',
  learn_image: 'https://dev-res.thumbr.io/images/home-learn-section.jpg',
  improve_title: 'Mejora tu Carrera profesional',
  improve_description: 'Además de cursos, con la Suscripción podrás apuntarte a tantas Carreras como quieras por una tarifa plana. Tienes más de 30 Carreras donde elegir, con rutas formativas y Tutor.',
  improve_image: 'https://dev-res.thumbr.io/images/home-improve-section.jpg',
  students_title: 'Más de 3 millones de usuarios en 160 países',
  students_description: 'Seguramente hasta tu vecino usará Tutellus, aunque no lo sepas :-) Únete y forma parte de la mayor revolución educativa de la historia.',
  students_image: 'https://dev-res.thumbr.io/images/home-students-section.png',
  register_title: 'Regístrate ahora, es gratis y accederás a todo el conocimiento del mundo',
  register_cta: 'REGISTRARME'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/home.js
// module id = 699
// module chunks = 0